import React from 'react'
import styled from '@emotion/styled'
import { graphql } from 'gatsby'

import type { Paragraph, ParagraphProps, ParagraphComponent } from '../types'
import type { FieldLink } from '../../../drupal'
import type { DrupalMedia } from '../../Media'

import { readableColor } from '../../ui/utils'
import { media } from '../../../styles/variables'
import Button from '../../ui/Button'
import Container from '../../Container'
import Media from '../../Media'

export interface MainPointParagraph extends Paragraph {
	backgroundColor?: {
		color: string
	}
	buttonColor?: {
		color: string
	}
	button: FieldLink
	body: {
		processed: string
	}
	marginTop: number
	relationships: {
		field_media: DrupalMedia
	}
}

const MainPoint: ParagraphComponent<MainPointParagraph> = ({ className, paragraph }) => (
	<Container id={`media-${paragraph.drupal_internal__id}`} className={className}>
		<div
			className="box"
			css={{
				backgroundColor: paragraph.backgroundColor?.color,
				color: paragraph.backgroundColor && readableColor(paragraph.backgroundColor.color)
			}}
		>
			<Media source={paragraph.relationships.field_media} />
			<div className="body">
				<div dangerouslySetInnerHTML={{ __html: paragraph.body.processed }} />

				{paragraph.button && <Button link={paragraph.button} color={paragraph.buttonColor?.color} />}
			</div>
		</div>
	</Container>
)

export default styled(MainPoint)<ParagraphProps<MainPointParagraph>>`
	.box {
		padding: var(--spacing) calc(var(--spacing) * 2);

		${media.up('md')} {
			display: grid;
			grid-template-columns: 1fr 2fr;
		}
	}

	.body {
		padding: 0 calc(var(--spacing) / 2);
		text-align: right;
		${media.down('md')} {
			text-align: center;
		}
	}
	h1,
	h2 {
		text-transform: uppercase;
	}

	h2 {
		font-size: 2.8rem;
		${media.down('md')} {
			font-size: 2rem;
		}
	}

	/*
	*  todo: Fix using predefined button sizes
	*/
	${Button} {
		font-size: 1.5rem;
		${media.down('md')} {
			font-size: 1.3rem;
		}
	}

	${({ paragraph: { marginTop } }) => ({
		marginTop: `calc(var(--spacing) * ${marginTop})`
	})}
`

export const query = graphql`
	fragment MainPointParagraph on paragraph__main_point {
		drupal_internal__id
		backgroundColor: field_background_color {
			color
		}
		buttonColor: field_button_color {
			color
		}
		body: field_text {
			processed
		}
		button: field_link {
			title
			link
			uri
		}
		marginTop: field_number
		relationships {
			field_media {
				__typename
				... on media__video {
					...MediaVideo
				}
				... on media__image {
					...MediaImage
				}
				... on media__svg_image {
					...MediaSvgImage
				}
			}
		}
	}
`
